import { Filters } from '@/types';
import { Widgets } from '@/components/widgets/types';

export interface ItemsList {
  title: string;
  value: number;
  percent?: number;
  total_price?: number;
}

export interface DefaultObject {
  [key: string]: unknown,
  total_count?: number;
  items?: ItemsList[];
}

export interface Orders {
  [key: string]: unknown,
  statuses?: DefaultObject
  payment_statuses?: DefaultObject
}

export interface FinalScore {
  name: string;
  value: string;
  grade: string;
}

export interface ResultItem {
  name: string;
  value: string;
  point: string;
}

export interface ResultService {
  [key: string]: unknown,
  company?: string;
  year?: string;
  quater?: number;
  final_score?: FinalScore;
  items?: ResultItem[];
}

export namespace Analytics {
  export enum Pages {
    ANALYTICS = 'analytics'
  }

  export interface Section {
    [key: string]: unknown,
    orders: Orders,
    certs: Widgets.Certs,
    returns_zip: DefaultObject,
    order_sides: DefaultObject,
    repair_models: DefaultObject,
    leads: DefaultObject,
    repair_types: DefaultObject,
    result_service_activity: ResultService,
    credit_line: DefaultObject
  }
}

export interface Users {
  full_name: string,
  id: number,
  laravel_through_key: number,
}

export interface Organizations {
  name_organization: string,
  id: number,
}

export interface Categories {
  id: number,
  name: string,
  slug: string,
}

export interface OperatioTypes {
  external_id: string,
  id: number,
  name: string,
}

export interface RepairsTypes {
  external_id: string,
  id: number,
  name: string,
}

export interface Clients {
  client_id: number,
  id_number: string,
  name_client_company: string
}

export interface CreditLineContract {
  id: number,
  name: string
  name_organization: string
  number_contract: string
}

export interface AnalyticsFilters extends Filters {
  [key: string]: unknown,
  order_user_id: number[],
  cert_user_id: number[],
  order_organization_id: number[],
  order_side_organization_id: number[],
  repair_model_organization_id: number[],
  repair_types_organization_id: number[],
  rsa_organization_id: number[],
  order_side_client_id: number | null,
  repair_types_client_id: number | null,
  repair_model_client_id: number | null,
  course_category_id: number | null,
  course_id: number | null,
  order_side_operation_type_id: number[],
  repair_model_operation_type_id: number[],
  repair_type_id: number[],
  external_organizations: string[],
  region: string | null,
  order_side_numbers: number[],
  order_side_dates: number[],
  repair_model_dates: number[],
  lead_dates: number[],
  repair_types_dates: number[],
  date: string,
  quarter: number | null,
  year: string | null,
  credit_line_organization_ids: number[],
  credit_line_contract_ids: number[],
  credit_line_organization_atols: number[]
}
